import React, { PureComponent } from 'react';
import { Row, Col, Form, Input, Button, Card } from 'antd';
import { Link } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { shape, func } from 'prop-types';
import { connect } from 'react-redux';
import LandingJourney from '../NewLanding/Journey';
import LandingContainer from '../../components/LandingContainer';
import StyledPayRollCardContactUs from './StyledPayRollCardContactUs';
import endPoints from '../../config/endPoints';
import { constants } from '../../devUtils';
import { SetContactUs } from '../../containers/HeaderContainer/actions';
import { getDefaultError } from '../../containers/HeaderContainer/selectors';
import { ShowRootAlert } from '../../containers/HeaderContainer';
import { AppWrappperHOC } from '../Root/HOC';
import { HelmetWrapper, SubTitle } from '../../components';

class PayrollCardContactUs extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(evt) {
    evt.preventDefault();
    const { form: { validateFields, resetFields }, onInitContactUs } = this.props;
    validateFields((err, values) => {
      if (!err) {
        onInitContactUs({ ...values, platform: 'payroll' });
        resetFields();
      }
    });
  }

  render() {
    const {
      form: { getFieldDecorator },
      apiResonse,
      location,
    } = this.props;
    return (
      <StyledPayRollCardContactUs>
        <HelmetWrapper location={location} />
        {ShowRootAlert(apiResonse)}
        <section className="padding-tb-3">
          <LandingContainer>
            <Row type="flex" justify="start" align="middle" gutter={32}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12} className="text-left">
                <h1 className="margin-t-1">
                Think beyond the pay cycle
                </h1>
                <p className="margin-t-2 margin-b-2">
                The Zaggle Yes Bank Payroll Card is a RUPAY powered physical card that works like any debit card, with several special features.
                  <br /><br />
                Provide real-time earned wage access to your unbanked workforce with Zaggle Payroll Card.
                </p>
                <img
                  src={endPoints.PAYROLL_CARD_LANDING_IMAGE.URL}
                  className="width-100"
                  alt={endPoints.PAYROLL_CARD_LANDING_IMAGE.ALT}
                />
              </Col>
              <Col xs={24} sm={24} md={2} lg={2} xl={2} />
              <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                <div className="form-bg">
                  <p className="font-18 nomargin">Fill the form to get the<br />Payroll Card Benefits</p>
                  <Form layout="vertical" onSubmit={this.handleSubmit}>
                    <Row type="flex" align="top" gutter={16}>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-right">
                      &#42; <span className="font-12">Indicates Required</span>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                          label="Name"
                        >
                          {getFieldDecorator('first_name')(
                            <Input placeholder="Enter Full Name" required type="text" />
                          )}
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                          label="Business Email ID"
                        >
                          {getFieldDecorator('email')(
                            <Input placeholder="Enter Email ID" required type="email" />
                          )}

                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                          label="Mobile Number"
                        >
                          {getFieldDecorator('phone')(
                            <Input placeholder="Enter Mobile Number" required type="number" min={1000000000} />
                          )}

                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                          label="City"
                        >
                          {getFieldDecorator('city')(
                            <Input placeholder="Enter Your City" required type="text" />
                          )}

                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                          label="Company Name"
                        >
                          {getFieldDecorator('company_name')(
                            <Input placeholder="Enter Company Name" required type="text" />
                          )}

                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form.Item
                          label="No of Employees"
                        >
                          {getFieldDecorator('employee_range')(
                            <Input placeholder="Employees" required type="number" min={1} />
                          )}

                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                        <Button htmlType="submit" className="btn ant-btn red-btn margin-t-1 bd-radius-50">
                        GET STARTED HERE
                        </Button>
                        <p className="margin-t-1">We will get back to you in 24 hours</p>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-tb-3">
          <LandingContainer>
            <Row align="middle" justify="start" type="flex" gutter={32}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <SubTitle fontWeight="800" className="nomargin font-20">Digitize Salaries for the Unbanked</SubTitle>
                <hr style={{ float: 'left' }} /><br />
                <p>With Zaggle Payroll Card, companies can pay Consultants/Contractors/Gig Workers /Temporary Employees/Unbanked Wage Workers without direct deposit to bank accounts, cash payments or paychecks.</p>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <img
                  src={endPoints.PAYROLL_POINTS_IMAGE.URL}
                  alt={endPoints.PAYROLL_POINTS_IMAGE.ALT}
                  className="width-100 margin-t-2"
                />
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-tb-3 employee-happy">
          <LandingContainer>
            <Row align="middle" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Row type="flex" justify="start" align="top" gutter={24}>
                  <Col xs={24} sm={24} md={8} lg={8} xl={8} className="margin-t-6">
                    <Card className="card-padding-10 text-center noborder">
                      <img src={endPoints.WIDE_ACCEPTANCE.URL} alt={endPoints.WIDE_ACCEPTANCE.ALT} />
                      <h2 className="font-14 padding-t-1">Wide Acceptance</h2>
                    </Card>
                    <Card className="card-padding-10 text-center noborder">
                      <img src={endPoints.PAY_ONLINE_UNIQUE_SECURITY.URL} alt={endPoints.PAY_ONLINE_UNIQUE_SECURITY.ALT} />
                      <h2 className="font-14 padding-t-1">Pay Online with Unique Security</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} xl={8} className="margin-t-3">
                    <Card className="card-padding-10 text-center noborder">
                      <img src={endPoints.ATM_WITHDRAWAL_FACILITY.URL} alt={endPoints.ATM_WITHDRAWAL_FACILITY.ALT} />
                      <h2 className="font-14 padding-t-1">ATM Withdrawal Facility</h2>
                    </Card>
                    <Card className="card-padding-10 text-center noborder">
                      <img src={endPoints.EASY_TO_USE.URL} alt={endPoints.EASY_TO_USE.ALT} />
                      <h2 className="font-14 padding-t-1">Easy to use</h2>
                    </Card>
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                    <Card className="card-padding-10 text-center noborder">
                      <img src={endPoints.COMPLETE_CONTROL.URL} alt={endPoints.COMPLETE_CONTROL.ALT} />
                      <h2 className="font-14 padding-t-1">Complete Control</h2>
                    </Card>
                    <Card className="card-padding-10 text-center noborder">
                      <img src={endPoints.MOBILE_APP.URL} alt={endPoints.MOBILE_APP.ALT} />
                      <h2 className="font-14 padding-t-1">Mobile App</h2>
                    </Card>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={2} lg={2} xl={2} />
              <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                <h2 className="font-18 nomargin">The Zaggle Payroll Card Advantage</h2>
                <hr /><br />
                <Link to={`${constants.LINK_PAYROLL_CARD}`} className="btn red-btn">GET ZAGGLE PAYROLL CARD</Link>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-tb-3 simple-steps">
          <LandingContainer>
            <Row align="middle" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
                <h2 className="font-18">How it Works</h2>
                <hr />
                <br />
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} className="text-center padding-tb-2">
                <img src={endPoints.ORDER_CARDS.URL} alt={endPoints.ORDER_CARDS.ALT} />
                <h2 className="font-16 margin-t-2">Order Cards</h2>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} className="text-center padding-tb-2">
                <img src={endPoints.START_PAYOUTS.URL} alt={endPoints.START_PAYOUTS.ALT} />
                <h2 className="font-16 margin-t-2">Start Payouts</h2>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8} className="text-center padding-tb-2">
                <img src={endPoints.OFFER_USER_ACCESS.URL} alt={endPoints.OFFER_USER_ACCESS.ALT} />
                <h2 className="font-16 margin-t-2">Offer User Access</h2>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center margin-t-1">
                <Link to={`${constants.LINK_PAYROLL_CARD}`} className="btn red-btn">Get a Demo</Link>
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <LandingJourney />
      </StyledPayRollCardContactUs>
    );
  }
}


PayrollCardContactUs.propTypes = {
  form: shape({}).isRequired,
  apiResonse: shape({}).isRequired,
  location: shape({}).isRequired,
  onInitContactUs: func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  onInitContactUs: (payload, otherParams = {}) => dispatch(SetContactUs(payload, otherParams)),
});

const mapStateToProps = createStructuredSelector({
  apiResonse: getDefaultError(),
});

const FORM_WRAPPER = Form.create({ name: 'normal_try_zaggle_edge' })(PayrollCardContactUs);
export default connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(FORM_WRAPPER));
export { FORM_WRAPPER, PayrollCardContactUs };




// WEBPACK FOOTER //
// client/containers/PayRollCardContact/index.jsx